// Shared data for all pricing plans
export const pricingData = {
  control: {
    name: "Control",
    description: "Data control and governance solutions",
    color: "#26a69a",
    lightColor: "#e0f2f1",
    hoverColor: "#00838F",
    gradientStart: "#E0F2F1",
    gradientEnd: "#B2DFDB",
    planColors: {
      essential: "#F7FBFA", // Control Essential
      plus: "#F0F7F6", // Control Plus
      complete: "#E8F3F1", // Control Complete
    },
    plans: [
      {
        id: "control-essential",
        name: "Control Essential",
        price: "$4",
        description:
          "Basic tools to identify and mitigate data risk through a shared accountability model. ",
        features: {
          "Data policy & insights": true,
          "Data owner engagement": true,
          "Data discovery and analysis scans (5)": true,
          "AI benchmarking": true,
          "Data security and governance workflows": "-",
          "User license management": "-",
          "Information lifecycle management": "-",
          "AI analytics": "-",
        },
      },
      {
        id: "control-plus",
        name: "Control Plus",
        price: "$9",
        description:
          "Scalable solutions to minimize data risk while continuously governing workspaces.",
        features: {
          "Data policy & insights": true,
          "Data owner engagement": true,
          "Data discovery and analysis scans (5)": true,
          "AI benchmarking": true,
          "Data security and governance workflows": "One data source",
          "User license management": true,
          "Information lifecycle management": "-",
          "AI analytics": "-",
        },
      },
      {
        id: "control-complete",
        name: "Control Complete",
        price: "$11",
        description:
          "Robust solution to improve security, manage cost, and optimize value of your SaaS investments.",
        features: {
          "Data policy & insights": true,
          "Data owner engagement": true,
          "Data discovery and analysis scans (5)": true,
          "AI benchmarking": true,
          "Data security and governance workflows": "Two data sources",
          "User license management": true,
          "Information lifecycle management": "10 GB / user",
          "AI analytics": true,
        },
      },
    ],
  },
  resilience: {
    name: "Resilience",
    description: "Data protection and backup solutions",
    color: "#4caf50",
    lightColor: "#e8f5e9",
    hoverColor: "#2E7D32",
    gradientStart: "#E8F5E9",
    gradientEnd: "#C8E6C9",
    planColors: {
      essential: "#F7FBF7", // Resilience Essential
      plus: "#F0F7F1", // Resilience Plus
      complete: "#E8F3E8", // Resilience Complete
    },
    plans: [
      {
        id: "resilience-essential",
        name: "Resilience Essential",
        price: "$7",
        description: "Address limitations of native data protection capabilities.",
        features: {
          "Out-of-the-box and configurable data protection": true,
          "Data protection for Microsoft 365": true,
          "Data protection for Entra ID": true,
          "Data discovery and analysis scans (5)": true,
          "Data protection for Dataverse ": "-",
          "Storage optimization": "-",
        },
      },
      {
        id: "resilience-plus",
        name: "Resilience Plus",
        price: "$10",
        description: "More advanced protection for collaboration and critical business operations.",
        features: {
          "Out-of-the-box and configurable data protection": true,
          "Data protection for Microsoft 365": true,
          "Data protection for Entra ID": true,
          "Data discovery and analysis scans (5)": true,
          "Data protection for Dataverse ": true,
          "Storage optimization": "-",
        },
      },
      {
        id: "resilience-complete",
        name: "Resilience Complete",
        price: "$12",
        description: "Enterprise protection at scale with intelligent management of storage, and more.",
        features: {
          "Out-of-the-box and configurable data protection": true,
          "Data protection for Microsoft 365": true,
          "Data protection for Entra ID": true,
          "Data discovery and analysis scans (5)": true,
          "Data protection for Dataverse ": true,
          "Storage optimization": "3 GB / User",
        },
      },
    ],
  },
}

// Helper function to get plan by name
export function getPlanByName(planName: string) {
  const [category, level] = planName.toLowerCase().split(" ")
  const categoryData = pricingData[category.toLowerCase() as keyof typeof pricingData]

  if (!categoryData) return null

  return categoryData.plans.find(
    (plan) =>
      plan.name.toLowerCase() === planName.toLowerCase() ||
      plan.id === `${category.toLowerCase()}-${level.toLowerCase()}`,
  )
}

// Helper function to get all features across all plans in a category
export function getAllFeaturesForCategory(category: "control" | "resilience"): string[] {
  const categoryData = pricingData[category]
  const allFeatures = new Set<string>()

  categoryData.plans.forEach((plan) => {
    Object.keys(plan.features).forEach((feature) => {
      allFeatures.add(feature)
    })
  })

  return Array.from(allFeatures)
}
